import React from 'react';
import { XIcon } from 'lucide-react';
interface SizeChartProps {
  isOpen: boolean;
  onClose: () => void;
  category: string;
}
export function SizeChart({
  isOpen,
  onClose,
  category
}: SizeChartProps) {
  if (!isOpen) return null;
  const isTopwear = ['Shirts', 'T-Shirts', 'Jackets', 'Hoodies'].includes(category);
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" data-id="element-321">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl overflow-hidden animate-in fade-in zoom-in duration-200" data-id="element-322">
        <div className="flex items-center justify-between p-4 border-b" data-id="element-323">
          <h3 className="text-lg font-semibold text-slate-900" data-id="element-324">
            Size Guide - {category}
          </h3>
          <button onClick={onClose} className="p-1 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors" data-id="element-325">
            <XIcon className="w-5 h-5" data-id="element-326" />
          </button>
        </div>

        <div className="p-6 overflow-x-auto" data-id="element-327">
          {isTopwear ? <table className="w-full text-sm text-left text-slate-600" data-id="element-328">
              <thead className="text-xs text-slate-700 uppercase bg-slate-50" data-id="element-329">
                <tr data-id="element-330">
                  <th className="px-6 py-3 rounded-tl-lg" data-id="element-331">Size</th>
                  <th className="px-6 py-3" data-id="element-332">Chest (in)</th>
                  <th className="px-6 py-3" data-id="element-333">Shoulder (in)</th>
                  <th className="px-6 py-3 rounded-tr-lg" data-id="element-334">Length (in)</th>
                </tr>
              </thead>
              <tbody data-id="element-335">
                <tr className="bg-white border-b" data-id="element-336">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-337">S</td>
                  <td className="px-6 py-4" data-id="element-338">38</td>
                  <td className="px-6 py-4" data-id="element-339">17.5</td>
                  <td className="px-6 py-4" data-id="element-340">27.5</td>
                </tr>
                <tr className="bg-slate-50 border-b" data-id="element-341">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-342">M</td>
                  <td className="px-6 py-4" data-id="element-343">40</td>
                  <td className="px-6 py-4" data-id="element-344">18</td>
                  <td className="px-6 py-4" data-id="element-345">28</td>
                </tr>
                <tr className="bg-white border-b" data-id="element-346">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-347">L</td>
                  <td className="px-6 py-4" data-id="element-348">42</td>
                  <td className="px-6 py-4" data-id="element-349">18.5</td>
                  <td className="px-6 py-4" data-id="element-350">29</td>
                </tr>
                <tr className="bg-slate-50 border-b" data-id="element-351">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-352">XL</td>
                  <td className="px-6 py-4" data-id="element-353">44</td>
                  <td className="px-6 py-4" data-id="element-354">19</td>
                  <td className="px-6 py-4" data-id="element-355">30</td>
                </tr>
                <tr className="bg-white" data-id="element-356">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-357">XXL</td>
                  <td className="px-6 py-4" data-id="element-358">46</td>
                  <td className="px-6 py-4" data-id="element-359">19.5</td>
                  <td className="px-6 py-4" data-id="element-360">31</td>
                </tr>
              </tbody>
            </table> : <table className="w-full text-sm text-left text-slate-600" data-id="element-361">
              <thead className="text-xs text-slate-700 uppercase bg-slate-50" data-id="element-362">
                <tr data-id="element-363">
                  <th className="px-6 py-3 rounded-tl-lg" data-id="element-364">Size</th>
                  <th className="px-6 py-3" data-id="element-365">Waist (in)</th>
                  <th className="px-6 py-3" data-id="element-366">Inseam (in)</th>
                  <th className="px-6 py-3 rounded-tr-lg" data-id="element-367">Length (in)</th>
                </tr>
              </thead>
              <tbody data-id="element-368">
                <tr className="bg-white border-b" data-id="element-369">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-370">
                    S (30)
                  </td>
                  <td className="px-6 py-4" data-id="element-371">30</td>
                  <td className="px-6 py-4" data-id="element-372">30</td>
                  <td className="px-6 py-4" data-id="element-373">40</td>
                </tr>
                <tr className="bg-slate-50 border-b" data-id="element-374">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-375">
                    M (32)
                  </td>
                  <td className="px-6 py-4" data-id="element-376">32</td>
                  <td className="px-6 py-4" data-id="element-377">31</td>
                  <td className="px-6 py-4" data-id="element-378">41</td>
                </tr>
                <tr className="bg-white border-b" data-id="element-379">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-380">
                    L (34)
                  </td>
                  <td className="px-6 py-4" data-id="element-381">34</td>
                  <td className="px-6 py-4" data-id="element-382">32</td>
                  <td className="px-6 py-4" data-id="element-383">42</td>
                </tr>
                <tr className="bg-slate-50 border-b" data-id="element-384">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-385">
                    XL (36)
                  </td>
                  <td className="px-6 py-4" data-id="element-386">36</td>
                  <td className="px-6 py-4" data-id="element-387">32</td>
                  <td className="px-6 py-4" data-id="element-388">43</td>
                </tr>
                <tr className="bg-white" data-id="element-389">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-390">
                    XXL (38)
                  </td>
                  <td className="px-6 py-4" data-id="element-391">38</td>
                  <td className="px-6 py-4" data-id="element-392">32</td>
                  <td className="px-6 py-4" data-id="element-393">43.5</td>
                </tr>
              </tbody>
            </table>}

          <div className="mt-6 bg-sky-50 p-4 rounded-lg" data-id="element-394">
            <h4 className="font-medium text-sky-900 mb-2" data-id="element-395">How to measure</h4>
            <ul className="text-sm text-sky-800 space-y-1 list-disc list-inside" data-id="element-396">
              {isTopwear ? <>
                  <li data-id="element-397">
                    <strong data-id="element-398">Chest:</strong> Measure around the fullest part of
                    your chest.
                  </li>
                  <li data-id="element-399">
                    <strong data-id="element-400">Shoulder:</strong> Measure from shoulder seam to
                    shoulder seam.
                  </li>
                  <li data-id="element-401">
                    <strong data-id="element-402">Length:</strong> Measure from the highest point of
                    shoulder to hem.
                  </li>
                </> : <>
                  <li data-id="element-403">
                    <strong data-id="element-404">Waist:</strong> Measure around your natural
                    waistline.
                  </li>
                  <li data-id="element-405">
                    <strong data-id="element-406">Inseam:</strong> Measure from the top of your inner
                    leg to the bottom.
                  </li>
                  <li data-id="element-407">
                    <strong data-id="element-408">Length:</strong> Measure from the top of the
                    waistband to the bottom hem.
                  </li>
                </>}
            </ul>
          </div>
        </div>
      </div>
    </div>;
}